const FORM = {
  TYPES: {
    PASSWORD: 'password',
    EMAIL: 'email',
    CHECKBOX: 'checkbox',
  },
};

export { FORM };
